import { useTranslation } from 'react-i18next';

import '../../../../components/Tooltip';
import { IOSShare } from '../../../../components/SVGIcons/IOSShare';
import { VerticalDots } from '../../../../components/SVGIcons/VerticalDots';

import styles from './InAppBlockedTooltip.module.scss';

const InAppBlockedTooltip = ({
  setTooltipRef,
  getTooltipProps,
  getArrowProps,
}: {
  setTooltipRef: any;
  getTooltipProps: any;
  getArrowProps: any;
}) => {
  const { t } = useTranslation();
  return (
    <div
      ref={setTooltipRef}
      {...getTooltipProps({
        className: 'tooltip-container',
        style: { border: '1px solid black', borderRadius: '1rem' },
      })}
    >
      <div className={styles.InAppBlockedTooltipContent}>
        <p>{t('auth.googleSignInNotSupported')}</p>
        <ul>
          <li>
            &bull;
            <b>{t('auth.ios')} </b>
            {t('auth.iosInstructions')}
            <IOSShare />
            {t('auth.inSafari')}
          </li>
          <li>
            &bull;
            <b> {t('auth.android')}</b>
            {t('auth.androidInstructions')}
            <VerticalDots />
            {t('auth.inBrowser')}
          </li>
        </ul>
      </div>
      <div {...getArrowProps({ className: 'tooltip-arrow' })} />
    </div>
  );
};

export default InAppBlockedTooltip;
